import React, { useEffect, useState } from 'react';

const MolecularBackground = () => {
  const [molecules, setMolecules] = useState([]);

  useEffect(() => {
    const generateMolecules = () => {
      const newMolecules = [];
      for (let i = 0; i < 15; i++) {
        newMolecules.push({
          id: i,
          x: Math.random() * 100,
          y: Math.random() * 100,
          size: 40 + Math.random() * 60,
          delay: Math.random() * 10,
          type: Math.random() > 0.5 ? 'hexagon' : 'benzene'
        });
      }
      setMolecules(newMolecules);
    };

    generateMolecules();
  }, []);

  return (
    <div className="molecular-background">
      {molecules.map((molecule) => (
        <div
          key={molecule.id}
          className={`molecule molecule-${molecule.type}`}
          style={{
            left: `${molecule.x}%`,
            top: `${molecule.y}%`,
            width: `${molecule.size}px`,
            height: `${molecule.size}px`,
            animationDelay: `${molecule.delay}s`
          }}
        >
          {molecule.type === 'hexagon' ? (
            <div className="molecule-hexagon"></div>
          ) : (
            <div className="molecule-benzene"></div>
          )}
        </div>
      ))}
    </div>
  );
};

export default MolecularBackground;
